import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QuestionBaseService {
  errorPresent: boolean = false;
  currentQuestion: any;
  Questions: Array<any> = new Array<any>();
  _dataModel: any;
  questionFlowComplete : Subject<boolean> = new Subject<boolean>();
  invitefetched : Subject<any> = new Subject<any>();
  hasTC : boolean = false;
  tcVerbiage : string;
  saveUrl : string;
  constructor() {
   }

  
  public get DataModel() : any {
    return this._dataModel;
  }
  
  public set DataModel(v : any) {
    this._dataModel = v;
  }
  
  moveNext() : boolean{
    console.log('moving in base service')
    if (this.currentQuestion.validate() || this.currentQuestion.canFailValidation) {
      this.errorPresent = false;
      this.currentQuestion.errorOnQuestion = false;
      // then we are good and can set this property on the model.
      this.DataModel[this.currentQuestion.propertyMapping] = this.currentQuestion.answer;
      // See if there is a next question to go to
      let candidates = this.Questions.filter((q) => {
        return q.questionOrder == (this.currentQuestion.questionOrder + 1);
      })
      if (candidates.length > 0) {
        this.currentQuestion = candidates[0];
        return true;
      }else{
        this.questionFlowComplete.next(true);
      }
    }
    else {
      this.errorPresent = true;
      this.currentQuestion.errorOnQuestion = true;
    }
  }

  moveBack():boolean{
    let candidates = this.Questions.filter((q) => {
      return q.questionOrder == (this.currentQuestion.questionOrder - 1);
    })
    if (candidates.length > 0) {
      this.currentQuestion = candidates[0];
      return true;
    }
  }

  getInvite(token : string) : void {
    console.log("I DO NOTHING");
  }
}
